export default __webpack_public_path__ + "img/system.360a36.svg";